<template>
    <v-dialog width="1000px" :value="showAttachDjUrlDialog" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar class="kbGold" dark text flat>
                <div class="text-h6">{{ $t('general.seeDjInYourWebSite') }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row>
                  <template v-if="urlToDj">
                    <v-col class="mt-4" cols="12" >
                        {{ $t('general.mustDoToSeeDjInWebSite') }}
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <pre class="layout mx-3" v-highlight style="box-shadow: none; border: 2px dashed;">
                            <code class="col col-12 xml white">{{urlToDj}}</code>
                        </pre>
                        <v-btn @click="copyToClipboard(urlToDj)"
                                color="primary"
                                style="position: absolute; right: 12px;"
                                text>
                            <v-icon left>
                                mdi-content-copy
                            </v-icon>
                            {{ $t('general.copy') }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col class="mt-4 text-center" cols="12" >
                        {{ $t('general.mustContactSupportToSeeDjInWebSite') }}
                    </v-col>
                  </template>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" @click="toggleModal(false)">
                    {{ $t('general.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      publicDjProfileUrl: state => state.events.newViewEditDjObj.publicProfileUrl
    }),
    showAttachDjUrlDialog: {
      get () {
        return this.$store.state.events.showAttachDjUrlDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_ATTACH_DJ_URL_DIALOG', value)
      }
    }
  },
  data () {
    return {
      urlToDj: ''
    }
  },
  methods: {
    copyToClipboard (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success(this.$t('general.urlCopied'))
      }).catch(() => {
        notifications.error(this.$t('general.errorCopyingUrl'))
      })
    },
    toggleModal (value) {
      this.showAttachDjUrlDialog = value
    }
  },
  watch: {
    publicDjProfileUrl (val) {
      this.urlToDj = `${val}`
    }
  }
}
</script>
